import { render, staticRenderFns } from "./epidemicRegister.vue?vue&type=template&id=91afbd30&"
import script from "./epidemicRegister.vue?vue&type=script&lang=js&"
export * from "./epidemicRegister.vue?vue&type=script&lang=js&"
import style0 from "./epidemicRegister.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports